import React, { createContext, useState, useEffect } from 'react';
import * as Sentry from '@sentry/nextjs';
import siftPageView from 'helpers/siftScience';

import { getFromChownowApi } from 'helpers/api';

export const CustomerContext = createContext();

export function loadUserAnalytics(userId) {
  // Set userId context for loggers
  Sentry.setUser({ id: userId });
  siftPageView(null, userId);
}
// eslint-disable-next-line react/prop-types
export default function CustomerProvider({ children }) {
  const [user, setUser] = useState(null);
  const [hasFetched, setHasFetched] = useState(false);

  // eslint-disable-next-line consistent-return
  async function fetchUserProfile() {
    const { data } = await getFromChownowApi('customer/me');
    if (data && !data.errors) {
      loadUserAnalytics(data.id);
      return data;
    }
  }

  const contextProps = {
    user,
    setUser,
    hasFetched,
    fetchUserProfile,
  };

  useEffect(() => {
    async function fetchUser() {
      const apiUser = await fetchUserProfile();
      setUser(apiUser);
      setHasFetched(true);
    }
    fetchUser();
  }, []);

  return <CustomerContext.Provider value={contextProps}>{children}</CustomerContext.Provider>;
}
